/* ──────────────────────────────────────────────────────────
   animation.js  –  GSAP + ScrollTrigger + Splitting.js setup
   ────────────────────────────────────────────────────────── */

import { gsap, ScrollTrigger } from "./gsap-setup.js";
import Splitting from "splitting";

export function initAnimations() {
    /* ───────────────────────────────
      1. Fade-in reveal elements
     ─────────────────────────────── */
    gsap.set(".animate-reveal", { autoAlpha: 0 });

    ScrollTrigger.batch(".animate-reveal", {
        batchMax: 10,
        onEnter: (els) => {
            gsap.to(els, {
                autoAlpha: 1,
                duration: 1,
                ease: "power2.inOut",
                clearProps: "all",
            });
        },
        start: (batch) =>
            batch.trigger.getBoundingClientRect().top + window.scrollY >
            window.innerHeight
                ? "top 80%"
                : "top bottom",
        once: true,
    });

    /* ───────────────────────────────
      2. Words slide up on scroll
     ─────────────────────────────── */
    const splitResults = Splitting({ target: ".animate-words-up", by: "words" });

    splitResults.forEach(({ words, el }) => {
        gsap.set(words, { yPercent: 100, autoAlpha: 0 });

        ScrollTrigger.batch(words, {
            batchMax: 15,
            onEnter: (els) => {
                gsap.to(els, {
                    yPercent: 0,
                    autoAlpha: 1,
                    stagger: 0.05,
                    duration: 0.6,
                    ease: "power2.out",
                    clearProps: "all",
                });
            },
            start:
                el.getBoundingClientRect().top + window.scrollY > window.innerHeight
                    ? "top 80%"
                    : "top bottom",
            once: true,
        });
    });
}

// Initialize on first paint
document.addEventListener("DOMContentLoaded", initAnimations);
